import { rgba } from "polished";
import styled from "styled-components";
import { Skeleton } from "../../../../structures/others/skeleton/styled.js";
import searcherSkeletonThemes from "./themes/index.js";
export const SearcherSkeletonWrapper = styled.div.withConfig({
    displayName: "styled__SearcherSkeletonWrapper",
    componentId: "sc-5be95d2d-0"
})`
	--searcher-skeleton-color-base: ${({ theme  })=>theme.colors.black.higher};
	--searcher-skeleton-color-effect: ${({ theme  })=>rgba(theme.colors.black.base, 0.04)};

	width: 100%;

	${Skeleton} {
		--skeleton-color-base: var(--searcher-skeleton-color-base);
		--skeleton-color-effect: var(--searcher-skeleton-color-effect);
	}

	${({ theme  })=>searcherSkeletonThemes[theme.id]?.SearcherSkeletonWrapper?.()}
`;

//# sourceMappingURL=styled.js.map